module.exports = __webpack_public_path__ + "img/info-outline.bc893937.svg";